// import actions
import multimediaAction from './actions/multimedia'

const actions = {
  ...multimediaAction,
}

export default {
  namespaced: true,
  actions,
}
